import { reactive } from 'vue'

const globalMsgState = reactive<{msgNum: number}>({
  msgNum: 0
})

export default globalMsgState
